import React from 'react'

import MainPanel from '../common/MainPanel'

import IntroImg from '../../assets/intro.png'

export default function Intro() {
  return (
    <MainPanel IntroImg={IntroImg}>
      <h1 className="h1">Trias Grant</h1>
      <div className="desc">
        <p>Trias Grant, a decentralized funding platform initiated by the Trias Foundation, has been officially launched on April 30.</p>
        <p>Trias Grant aims to reinvent the crowdfunding model through Web 3.0 by supporting valuable projects and solving the lack of transparency and efficiency in early-stage funding.</p>
        <p>The scope of funding includes, but is not limited to Trias eco projects, fintech initiatives, philanthropic deeds, and academic research. All participants can initiate funding plans through the TRIAS DAO, and approved projects can start a grant pool on the Trias Grant to receive financial support from the community and Trias foundation.Trias Grant uses quadratic vote to select projects and the community can stake and vote to participate and get rewards. TRIAS token will be needed for the votes, as well as the grants, creating an economic model of a dynamic exchanges of tokens.</p>
      </div>
    </MainPanel>
  )
}